export default class PagedRequest {
  pageNumber: number = 1;
  pageSize: number = 30;
}

export class PagedResponse<T> {
  totalItems: number = 0;
  totalPages: number = 0;
  items: T[] = [];
}
